import { publish } from 'pub-sub';
// import { setup_actions } from 'webapp3-lpl';

export function load_lpl(): void {
	// setup_actions();
	publish('site/homepage');
}
